import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id CB3E6FC0-B9F1-4CAE-AAB9-72946D7E7064
 * name star-four-points-box-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-four-points-box-outline.svg
 * tags
 * - Shape 
 */
export const StarFourPointsBoxOutlineIcon = createSvgIcon(<><path d="M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M5 19H19V5H5V19Z" /></>, 'StarFourPointsBoxOutlineIcon');
export default StarFourPointsBoxOutlineIcon